<template>
<v-list-tile >
  <v-list-tile-avatar >
    <v-icon v-if='!isFailure' >check</v-icon>
    <v-icon v-else >close</v-icon>
  </v-list-tile-avatar>
  <v-list-tile-content v-if='comm' >
    <v-list-tile-title v-if='comm.preferred_transport === "email"'>
      <span v-for='email in comm.recipient_emails' :key='email' >{{email}}</span>
    </v-list-tile-title>
    <v-list-tile-title v-if='comm.preferred_transport === "sms"'>
      <span >{{comm.recipient_phone_number}}</span>
    </v-list-tile-title>
  </v-list-tile-content>
  <v-list-tile-action>
    {{status}}
  </v-list-tile-action>
</v-list-tile>
</template>
<script>
export default {
  name: 'CommunicationWatcher',
  props: {
    messageId: { required: true }
  },
  computed: {
    comm () {
      return this.$store.getters.getCommunication(this.messageId)
    },
    isFailure () {
      return (this.status.toLowerCase() === 'failed')
    },
    status () {
      if (this.comm) {
        if (this.comm.communicationstatus && this.comm.communicationstatus.length > 0) {
          let stat = this.comm.communicationstatus[this.comm.communicationstatus.length - 1]
          if (stat) {
            return stat.status
          }
        }
        return 'sent'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationWatcher.vue?81ee783c